/**
 * Widget to perform online assessment. This is the next generation intended to be reusable
 * in different project and not dependent on GEMSJ/GEMS2/ATSEP code.
 *
 * Joe Desbonnet
 *
 * Configuration variables:
 *
 * mctId: ID of assessment
 *
 * mctMetadataUrlFn: a function what will generate a URL where the MCT
 * metadata can be downloaded. Takes one parameter: mctId
 *
 * mctItemUrlFn: a function what will generate a URL where an item
 * can be downloaded. Takes two parameters: mctId and itemId.
 *
 * mctResponseUrlFn: URL which a response to an item will be posted
 *
 * heartbeatUrl: (optional) URL which will be invoked periodically. If no
 * URL is specified the heartbeat function is disabled.
 * heartbeatInterval: (optional)
 *
 * mctSubmitUrlFn:
 *
 *
 * clientFlagStateEnable: (optional) If set true then item flagging state will
 * be stored on the client.
 *
 */


window.OLE = function () {

	"use strict";


	var g_currentItemIndex;

	//
	// Private scope variables and methods
	//

	// Mantis 0002235. Optionally display version of exam widget in client UI
	// For convenience set the version to match the CVS version
	var VERSION = '1.87';

	var USE_FLAG_ITEM_CHECKBOX = false;
	var USE_FLAG_ITEM_BUTTON = true;

	// Configuration (set with public method setConfiguration())
	// Populate optional parameters with default values.
	var cfg = {
			heartBeatInterval: 15000,
			flagItemLabel: "Flag this item for attention later",
			showClientVersion: false
	};

	var alertEl;	// Important alerts go here

	var buttonBarEl; // Optional location for UI buttons

	var itemStemEl; // Item stem (question body)
	var itemAnswersEl; // Item answers
	var itemAnswersListEl;

	var prevItemBtnEl;  // Previous item button
	var nextItemBtnEl;	// Next item button

	var submitItemBtnEl; // Submit item button. Only visible when interactive feedback is on

	var flagItemDivEl;
	var flagItemCbEl;
	var flagItemBtn;
	var commentItemBtn;
	var submitBtnEl;

	var clockDivEl; // Clock wrapper DIV (incl 'Time remaining' text)
	var clockEl; // Clock value

	// Where MCT status (incl item status) is enclosed
	var mctStatusEl;
	var itemStatusEl;

	// Wrapper DIV element for progress bar
	var progressBarEl;
	var progressBarSliderEl;
	var progressBarMsgEl;

	// MCT assessment metdata
	var examInfo;

	var clockTimer;
	var heartbeatTimer;

	var imgZoomPanel;

	var clockRunning = false;
	var clockStartTime;
	var clockStartValue;

	/** Element IDs of elements that are hidden when an exam is paused. */
	var suspendHideElIds = ["oleItem","mctStatusPane","olePrevItemBtn","oleNextItemBtn",
							"oleFlagItemBtn","oleCommentItemBtn", "oleSubmitBtn", "olesubmitItemBtn",
							"rb_0","rb_1","rb_2","rb_3"
							];

	/**
	 * Mantis 0002073. Store the selected answer prior to submitting the question. Necessary
	 * so question submission can be separated from clicking an answer box
	 */
	var selectedRadioElement = null;

	/**
	 * The answer index of the current item, as it was when retrieved from
	 * the server. Retained so we can revert to it if sending a user response
	 * fails. The client must always reflect the true state of the server
	 * Introduced in response to Mantis 0002121 */
	var oldAnsIndex;

	/**
	 * Defines whether participant can respond to an item. Further participant
	 * responses need to be disabled while client waits for server to confirm
	 * the current response. Otherwise server can confirm responses in an order
	 * other than that in which they were sent - which can leave client item
	 * index in an incorrect state.
	 * Introduced in response to Mantis 0002121.
	 */
	var responsesEnabled = true;

	/**
	 * This variable is to throttle ajax calls. The idea is to only fire off
	 * one ajax call at a time and wait until it returns rather than fire off
	 * another. The ajax failure function resets this variable to deal with
	 * the function never returning.
	 */
	var waitingOnAjaxReturn = false;
	var waitingOnAjaxReturnCounter = 0;

	/**
	 * Convenience method to hide/unhide a set of elements in one op.
	 * @param elIds String[] Array of element ids
	 * @param vis String One of 'visibile' or 'hidden'
	 * @return void
	 */
	function setElementsVisibility ( elIds, vis ) {

		var i, n, el;
		for ( i = 0, n = elIds.length; i < n; i++ ) {
			el = document.getElementById( elIds[i] );
			if ( el !== null) {
				el.style.visibility= vis;
			}
		}
	}


	function clockResume () {

		// Mantis 0002121. Update the state of the Item Matrix to retrieve the
		// latest state of the exam from the server. Not effecient but ensures
		// that no answer can get lost when exam is paused.
		refreshExamInfo();
		setElementsVisibility(["oleWaitMessage"],"hidden");
		setElementsVisibility(suspendHideElIds,"visible");
		startClockTimer();
		YAHOO.util.Dom.removeClass(clockEl,"ckPause");
		clockRunning = true;
	}


	function clockPause () {

		setElementsVisibility(suspendHideElIds,"hidden");
		setElementsVisibility(["oleWaitMessage"],"visible");
		imgZoomPanel.hide();
		stopClockTimer();
		YAHOO.util.Dom.addClass(clockEl,"ckPause");
		clockRunning = false;
	}


	function isClockRunning() {
		return clockRunning;
	}


	/**
	 * Update the item matrix and progress bar to match the current state of
	 * participant's exam on the server.
	 * Introduced in response to Mantis 0002121.
	 */
	function refreshExamInfo() {

		// Generate MCT metadata URL and issue GET request
		var metadataUrl = cfg.mctMetadataUrlFn(cfg.mctId);
		YAHOO.util.Connect.asyncRequest ("GET",
				metadataUrl + "&t=" + new Date().getTime(), {
			success: function (o) {

				// Parse metadata and keep object for future reference
				examInfo = YAHOO.lang.JSON.parse(o.responseText);
				updateExamInfo( examInfo.items );
				updateItemMatrix();
				updateProgressBar();

			}, // end success() function
			failure: function (o) {
				reportError (o.responseText);
				// asyncLog('failed to refreshExamInfo', null , o.responseText);
			}
		}); // end asyncRequest()

	}


	function updateExamInfo( itemUpdate ) {

		var i;
		for ( i = 0; i < examInfo.items.length; i++ ) {
			examInfo.items[i].response = itemUpdate[i].response;
		}
	}


	/**
	 *
	 */
	function updateItemMatrix() {

		var tdEl = null;
		var itemAnsweredArray = [];
		var i;

		for ( i = 0; i < examInfo.items.length; i++ ) {
			// Mantis 0002235: Consciously using != instead of !== here. Using type
			// safe version leads to inconsistency between server and client
			// TODO Investigate Why!
			itemAnsweredArray[i] = (examInfo.items[i].response != null);
			tdEl = getItemStatusEl(i);
			if ( itemAnsweredArray[i] == true ) {
				YAHOO.util.Dom.removeClass( tdEl,"unanswered" );
				YAHOO.util.Dom.removeClass( tdEl,"sending" );
				YAHOO.util.Dom.addClass( tdEl,"answered" );
			} else {
				YAHOO.util.Dom.removeClass( tdEl,"answered" );
				YAHOO.util.Dom.removeClass( tdEl,"sending" );
				YAHOO.util.Dom.addClass( tdEl,"unanswered" );
			}
		}
	}


	/**
	 * Report an error message
	 */
	function reportError (message) {
		alertEl.className = "oleAlertActive";
		alertEl.innerHTML = "<b>!</b>" + message;
	}


	function clearError () {
		alertEl.className = "";
		alertEl.innerHTML = "";
	}


	/**
	 * Apply a loading animation (spinning circle) to an element to indicate
	 * that activity is in progress
	 *
	 * @param elId : The element ID to which the loading animation is to be applied.
	 * @param onOff: Boolean value. If 'true' animation is applied, 'false' removed.
	 * @return void
	 */
	function loaderAnimation (elId, onOff) {

		var el = document.getElementById( elId );
		if (el === null) {
			return;
		}
		if (onOff) {
			YAHOO.util.Dom.addClass(el,"showLoaderAnimation");
		} else {
			YAHOO.util.Dom.removeClass(el,"showLoaderAnimation");
		}
	}


	/**
	 * Get item status TD element for itemIndex.
	 * @param itemIndex (0 = first item etc)
	 * @return TD table element
	 */
	function getItemStatusEl (itemIndex) {

		return document.getElementById("q_" + itemIndex);
	}


	/**
	 * Returns true if item is flagged on client side storage. N/a if
	 * flagging state is stored on server.
	 * @param itemIndex
	 * @return Boolean. True if the item at itemIndex is flagged.
	 */
	function isFlagged (itemIndex) {

		var el = getItemStatusEl(itemIndex);
		return YAHOO.util.Dom.hasClass(el,"unsure");
	}


	function setFlagged (itemIndex, state) {

		var el = getItemStatusEl(itemIndex);
		var url = cfg.mctFlagItemUrlFn(cfg.mctId, itemIndex, state );
		el.flaggedItem = state;

		YAHOO.util.Connect.asyncRequest ("POST", url,
				{
					success: function (o) {
							// no action
					},
					failure: function (o) {
						// asyncLog('Failed to setFlagged',null,o.responseText);
						reportError (o.responseText);
					}
				}
		);
	}


	/**
	 *
	 * Mantis 0002073. Add the itemStatus (Status in this context is whether the question
	 * has been answered) to the radio button element
	 */
	function createRadioEl (elId, fieldName, checked, value, itemStatus ) {

		if ( cfg.nativeRadioButtonEnable ) {
			return createNativeRadioEl(elId, fieldName, checked, value );
		}
		return createCustomRadioEl(elId, fieldName, checked, value, itemStatus );

	}


	/**
	 * Broken Microsoft IE6 has problems with dynamically generated radio buttons. Create
	 * radio button element in a way that will work around Microsoft IE 6 bugs.
	 * See http://cf-bill.blogspot.com/2006/03/another-ie-gotcha-dynamiclly-created.html
	 */
	function createNativeRadioEl ( id, fieldName, checked, value ) {

		var radioEl;
		try {
			radioEl = document.createElement("<input type='radio' name='" + fieldName + "' "
				+ " id='" + id + "' "
				+ ( checked ? " checked='yes' " : "")
				+ " value='" + value + "' "
				+ "/>");

		} catch( err ) {
			radioEl = document.createElement('input');
			radioEl.setAttribute('type','radio');
			radioEl.setAttribute('id',id);
			radioEl.setAttribute('name',fieldName);
			radioEl.setAttribute('value',value);
			radioEl.checked = checked;
		}
		radioEl.answerIndex = value;
		radioEl.className="oleRb";
		return radioEl;
	}


	/**
	 * Create a DOM element that emulates the functionality of a radio button set, but
	 * allows for more control over behaviour (eg unselect) and styling. This is
	 * accomplished with a DIV (with style 'oleRadioBtn' and additional style 'checked'
	 * to indicate that it's a checked radio button.
	 */
	function createCustomRadioEl ( elId, fieldName, checked, value, itemStatus ) {

		var radioEl = document.createElement("div");
		radioEl.id = elId;
		radioEl.fieldName = fieldName;
		// Mantis 0002073. In show feedback mode, grey out the item/question
		// once it has been answered
		// Mantis 0002252. In preview mode, show the correct response
		if ( cfg.showFeedback || cfg.isPreview ) {
			if ( itemStatus === null ) {
				radioEl.className = (checked ? "oleRadioBtn checked" : "oleRadioBtn");
			} else {
				radioEl.className = (checked ? "oleRadioBtnGray checked" : "oleRadioBtnGray");
			}
		} else {
			radioEl.className = (checked ? "oleRadioBtn checked" : "oleRadioBtn");
		}
		radioEl.answerIndex = value;
		return radioEl;
	}


	/**
	 * Called by radio button click handler prior to submitting to server. If using
	 * custom radio widget then update elements. No action if using native radio buttons.
	 */
	function updateRadioWidget (radioEl) {

		if (cfg.nativeRadioButtonEnable) {
			// Native widgets update themselves
			return;
		}

		var preClickState = isRadioButtonChecked(radioEl);
		var postClickState = ! preClickState;
		var el;
		var i = 0;

		// Clear all radio buttons
		while ( (el = document.getElementById("rb_" + i)) !== null) {
			el.className = "oleRadioBtn";
			el.checked = false;
			i++;
		}

		// The 'radioEl' to checked if it wasn't in that state before
		// else leave it unchecked.
		if ( postClickState === true ) {
			YAHOO.util.Dom.addClass( radioEl,"checked" );
			radioEl.checked = true;
		}

		// IE bug work-around
		for ( i = 0; i < 4; i++ ) {
			el = document.getElementById( "rb_"+i );
			if ( el != null ) {
					el.style.visibility="visible";
			}
		}
	}


	/**
	 * @return Boolean value. True if the radio button element is checked.
	 */
	function isRadioButtonChecked (radioEl) {

		if ( cfg.nativeRadioButtonEnable ) {
			return radioEl.checked;
		}
		return YAHOO.util.Dom.hasClass( radioEl, "checked" );
	}


	/**
	 * Create question matrix normal standards compliant browsers
	 *
	 * @param questionIds Array of question ID (integers).
	 *
	 * @returns DOM element (a TABLE) of the question matrix
	 */
	function ole_createQuestionMatrix (questionIds) {

		var tableEl = document.createElement("table");
		var trEl = document.createElement("tr");
		var tdEl;
		var i, nq;
		tableEl.appendChild(trEl);

		for (i = 0, nq = questionIds.length; i < nq; i++) {

			tdEl = document.createElement("td");
			createQuestionMatrixCell (tdEl, i, questionIds[i]);
			trEl.appendChild (tdEl);

			// new row
			if (i % 6 === 5) {
				trEl = document.createElement("tr");
				tableEl.appendChild(trEl);
			}
		}
		return tableEl;
	}


	/**
	 * Create question matrix for broken browsers (IE)
	 */
	function createQuestionMatrixIE (questions) {

		var tableEl = document.createElement("table");
		var cellEl;
		tableEl.id = "oleItemStatusTable";
		var nRows = Math.ceil (questions.length / cfg.itemStatusColumns);
		var rows = [];
		var i,j,questionIndex=0;

		for (i = 0; i < nRows; i++) {
			rows[i] = tableEl.insertRow(i);
			for (j = 0; j < cfg.itemStatusColumns; j++) {
				cellEl = rows[i].insertCell(j);
				createQuestionMatrixCell (cellEl, questionIndex, questions[questionIndex]);
				questionIndex++;

				if (questionIndex >= questions.length) {
					break;
				}
			}
		}
		return tableEl;
	}


	/**
	 * Populate a TD DOM element of a QuestionMatrix. Set event handlers also.
	 *
	 * @param tdEl DOM element of table cell (TD)
	 * @param question Question object
	 */
	function createQuestionMatrixCell (tdEl, itemIndex, item) {

		tdEl.id = "q_" + itemIndex;
		tdEl.itemIndex = itemIndex;
		// Display label is index+1 (ie first item is "1")
		tdEl.appendChild ( document.createTextNode((itemIndex+1)) );

		if ( item.response == null ) {
			tdEl.className = "unanswered";
		} else {
			tdEl.className = "answered";
		}

		if (item.flagged) {
			YAHOO.util.Dom.addClass(tdEl, "unsure");
		}
		if (item.commented) {
			YAHOO.util.Dom.addClass(tdEl, "matrix-item-commented");
		}

		tdEl.answerIndex = item.response;

		// Attach a click handler on the TD element
		YAHOO.util.Event.on(tdEl,"click", function (e,o) {
			// Mantis 0002121. Don't respond to clicks if response are
			// temporarily disabled
			if ( responsesEnabled ) {
				// parameter 'o' is the tdEl
				clearError();
				getAndDisplayItem(o.itemIndex);
				g_currentItemIndex = o.itemIndex;
			}
		}, tdEl /* tdEl is param 'o' in click handler */);
	}


	/**
	 * Function called every second by Javascript setInterval() function.
	 * Format is mmm:ss eg 32:12 (32 minutes, 12 sec),
	 * 123:22 (2 hours, 3 minutes, 22 seconds).
	 *
	 * @return void
	 */
	function updateClock () {

		var now, clockTime;
		// Nothing to do if clock is paused
		if ( ! isClockRunning() ) {
			return;
		}

		now = new Date().getTime();

		// Mantis 0002328: delta is calculated differently in elapsed time mode
		// because clock is incrementing, not decrementing...
		if ( !cfg.elapsedTime ) {
			clockTime = clockStartValue - ((now-clockStartTime)/1000)|0;
		} else {
			clockTime = clockStartValue - ( (clockStartTime-now)/1000 )|0;
		}

		if (clockTime < 0 && !cfg.isPreview ) {
			stopBackgroundTasks();
			window.location=cfg.mctOverUrlFn(cfg.mctId);
			return false;
		}
		if ( !cfg.isPreview ) {
			updateClockDisplay(clockTime);
		}
	}


	/**
	 * Write into the clock element the remaining time formatted as mmm:ss.
	 * @param clockTime int Clock time in seconds.
	 */
	function updateClockDisplay(clockTime) {
		if(clockTime === null) return;

		var hours, minutes, seconds, minStr, timeStr;

		// Mantis 0002328: Don't change the clock colour in autoSubmit mode
		if ( cfg.autoSubmit ) {
			if ( cfg.elapsedTime ) {
				if ( (timeAllowed - clockTime) < 300 ) {
					YAHOO.util.Dom.replaceClass(clockDivEl,"timeLow","timeVLow");
				} else if ( (timeAllowed - clockTime) < 600 ) {
					YAHOO.util.Dom.addClass(clockDivEl,"timeLow");
				} else {
					YAHOO.util.Dom.addClass(clockDivEl,"timeNormal");
				}
			} else {
				if ( clockTime < 300 ) {
					YAHOO.util.Dom.replaceClass(clockDivEl,"timeLow","timeVLow");
				} else if ( clockTime < 600 ) {
					YAHOO.util.Dom.addClass(clockDivEl,"timeLow");
				} else {
					YAHOO.util.Dom.addClass(clockDivEl,"timeNormal");
				}
			}
		} else {
			YAHOO.util.Dom.addClass(clockDivEl,"timeNormal");
		}

		// Mantis 0002252
		if ( cfg.isPreview ) {
			YAHOO.util.Dom.addClass(clockDivEl,"timePreview");
		}

		if ( cfg.unProctored ) {
			hours = (clockTime / 3600) | 0;
			minutes = ( (clockTime / 60) - (hours* 60) ) | 0;
			seconds = (clockTime % 60);

			if ( minutes === 0 ) {
				minStr = "00";
			} else if ( minutes < 10 ) {
				minStr = "0" + minutes;
			} else {
				minStr = minutes;
			}
			timeStr = ( hours > 0 ? hours + " : " : "" )
			+ minStr + " : "
			+ (seconds < 10 ? "0"+seconds : seconds);

		} else {
			minutes = (clockTime / 60) | 0;
			seconds = (clockTime % 60);
			timeStr = (minutes < 10 ? "0" + minutes : minutes)
				+ " : "
				+ (seconds < 10 ? "0"+seconds : seconds);
		}
		//Mantis 0002252
		if ( cfg.isPreview && clockTime === 0 ) {
			timeStr = "--:--";
		}
		clockEl.innerHTML = timeStr;
	}


	/**
	 * Retrieve item from server and display on screen.
	 *
	 * @param itemIndex : the index of the item (0 = first item .. etc)
	 * @return void
	 */
	function getAndDisplayItem ( itemIndex ) {

		// Display loader animation in item pane
		loaderAnimation(cfg.itemPaneId,true);

		var itemInfo;
		var itemUrl = cfg.mctItemUrlFn(cfg.mctId,itemIndex);

		YAHOO.util.Connect.asyncRequest ("GET",
				itemUrl
				+ "&t=" + new Date().getTime(), {
			success: function (o) {

				// Clear loader animation
				loaderAnimation(cfg.itemPaneId,false);
				itemInfo = YAHOO.lang.JSON.parse(o.responseText);

				// Status codes:
				// 0 : all is normal
				// 450: exam submitted (Updated to handle this case, see Mantis 0002181)
				// 451: exam is over
				// 452: exam voluntarily submitted
				// 453: exam timeout
				// 454: terminated by examiner (individual)
				// 455: terminated by examiner (all)
				if (itemInfo.status >= 450 && !cfg.isPreview ) {
					stopBackgroundTasks();
					window.location=cfg.mctOverUrlFn(cfg.mctId);
					return;
				}
				if (itemInfo.status !== 0) {
					// Some error has occured
					alert ( cfg.errorCodeMessage + " " + itemInfo.status + "\n"
						+ itemInfo.errorText);
					return;
				}
				// Item retrieved OK
				displayItem(itemInfo);
				// Mantis 0002121 Store the existing answer index for this item -
				// we will need to revert to it if sending the user reponse fails
				oldAnsIndex = itemInfo.response;
				navBtnStatusUpdate();
			},
			failure: function (o) {
				// asyncLog('Failed to getAndDisplayItem',null,o.responseText);
				displayConnectionError (o);
			}

		});
	}


	/**
	 * Advance to next item (if not already at last item). Used by nav button click handlers.
	 * @return void
	 */
	function nextItem () {

		var nq = examInfo.items.length;
		if ( g_currentItemIndex < nq - 1 ) {
			clearError();
			getAndDisplayItem(++g_currentItemIndex);
		}
		navBtnStatusUpdate();
	}


	/**
	 * Back to previous item (if not already at first item). Used by nav button click handlers.
	 * @return void
	 */
	function prevItem () {

		if (g_currentItemIndex > 0) {
			clearError();
			getAndDisplayItem(--g_currentItemIndex);
		}
		navBtnStatusUpdate();
	}


	/**
	 * Enable/disable navigation (prev/next) item buttons depending on position in MCT.
	 * @return void
	 */
	function navBtnStatusUpdate () {

		prevItemBtnEl.disabled = (g_currentItemIndex === 0);
		nextItemBtnEl.disabled = (g_currentItemIndex === examInfo.items.length-1);

		// Mantis #1967
		if (cfg.prevItemBtnDisabledLabel !== undefined) {
			if (g_currentItemIndex === 0) {
				prevItemBtnEl.innerHTML = cfg.prevItemBtnDisabledLabel;
			} else {
				prevItemBtnEl.innerHTML = cfg.prevItemBtnLabel;
			}
		}
		if (cfg.nextItemBtnDisabledLabel!==undefined) {
			if (g_currentItemIndex == examInfo.items.length-1) {
				nextItemBtnEl.innerHTML = cfg.nextItemBtnDisabledLabel;
			} else {
				nextItemBtnEl.innerHTML = cfg.nextItemBtnLabel;
			}
		}
	}

	/**
	 * Enable/disable submit item button depending on whether item has already
	 * been submitted
	 * Introduced in response to Mantis 0002073
	 * @param int itemIndex
	 * @return void
	 */
	function submitBtnStatusUpdate ( itemInfo ) {

		// Mantis 0002073. If the item/question has been answered, it should be disabled
		if (itemInfo.response != null ) {
			submitItemBtnEl.disabled = true;
		} else {
			submitItemBtnEl.disabled = false;
		}
	}


	/**
	 * Called by #oleItemFlagBtn onClick handler. Button version of flag/unflag.
	 *
	 * @return void
	 */
	function toggleItemFlag_BtnVer () {

		flagItemBtn.checked = ! flagItemBtn.checked;
		flagItemBtn.className = flagItemBtn.checked ? "flagged" : "";

		var tdEl = getItemStatusEl(g_currentItemIndex);

		if (flagItemBtn.checked === true) {
			YAHOO.util.Dom.addClass(tdEl,"unsure");
		} else {
			YAHOO.util.Dom.removeClass(tdEl,"unsure");
		}
		clearError();
		setFlagged( g_currentItemIndex,flagItemBtn.checked );

	}

	function escapeRegExp(str) {
		return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
	}

	function renderGameQuestion(questiontext,index,answers){
		// console.log('rendering game');
		var GQIdentifierHead = new RegExp('^\\s*<span>\\s*' + escapeRegExp(cfg.gameQuestionIdentifierHead), "");
		var GQIdentifierTail = new RegExp(escapeRegExp(cfg.gameQuestionIdentifierTail) + '\\s*<\\s*\\\/\\s*span>\\s*$', "");
		var cleaned_questiontext = questiontext
			.replace(GQIdentifierHead,'') 	// remove CDATA header
			.replace(GQIdentifierTail,'')	// remove CDATA footer
			.replace(/<\/?[^>]+(>|$)/g, "")				// remove any html tags
			.replace(/\s+/g,'')							// remove any whitespace
		;

		var dragdrop_type = ["dragdrop","draganddrop","drag&drop","dr&dr","d&d"];

		var game_info = cleaned_questiontext.split(':');
		var game_type = game_info[0];
		var game_name = game_info[1];

		if (dragdrop_type.includes(game_type.toLowerCase())) initDragDrop(game_name,index,answers);
		else return "⚠️ ⚠ Error while loading the question. ⚠ ⚠️";

		// Flattened the string declaration to make it compatible with IE11
		var html = '<div class="player"><div class="matchgame"><div id="game_container"><div class="in-line"><div class="name contentdown"> <b>Equipment icons:</b></div><div class="buttonsname"><button id="resize" class="expand btn-dragdrop-expand mt-1"> <i class="fa fa-expand r"></i> </button> <!-- Size button --> &nbsp;	</div> </div><div id="draggable_container"></div><div id="droppable_container"></div> </div>	</div></div>';

		// console.log(game_name);
		return html;
	}

		//////////////////////////////////////////////////////////////////////

		function displayItem(itemInfo)
		{
			return originalDisplayItem( itemInfo );

			// UNCOMMENT THE FOLLOWING AND DELETE THE ABOVE LINE FOR ONLINE ESSAY EXAMS
			// UNCOMMENT THE FOLLOWING AND DELETE THE ABOVE LINE FOR ONLINE ESSAY EXAMS
			//// The original displayItem is now called originalDisplayItem
			//// The original displayItem is now called originalDisplayItem
			//// The original displayItem is now called originalDisplayItem
			////
			//// The original function is very long and should be broken into smaller
			//// managable functions. Here we split the code for essay and mcq and
			//// possibly other question types.
			//var q = itemInfo.item;
			//if ( q.question_type == "essay" ) return displayEssayQuestion( itemInfo );
			//else                              return originalDisplayItem( itemInfo ); // i.e. for MCQ
		}

		//////////////////////////////////////////////////////////////////////

		function displayEssayQuestion( itemInfo )
		{
			var q = itemInfo.item;

			// If configured to show the heading/title string then do so....
			var itemStemHTML =
					"<span class='itemNumber'>"
					+ (g_currentItemIndex+1)
					+ ".</span> "
					+ "<span class='itemHeading'>"
					+ (!cfg.hideQuestionHeader ? q.heading : "")
					+ "</span>"
					+ (!cfg.hideQuestionHeader ? "<br /><br />" : "")
					;
			itemStemEl.innerHTML = itemStemHTML;

			// Now display the question and the ckeditor box.....
			var htmlForAnswersSection = "<span><b>" + q.questionText + "</b><br><br>"
										+ "<textarea name=\"editor1\" id=\"editor1\" rows=\"10\" width=\"100%\">This is my textarea to be replaced with CKEditor.</textarea>"
										+ "</span>";
			itemAnswersEl.innerHTML   = htmlForAnswersSection;

			// The grid of question numbers on the right is called the Status Matrix.
			// The following function will update it to correctly show a black rectangle
			// around the current question.
			updateTheStatusMatrix();

			// The following 'inserts' the ckeditor, puts the trainees essay (so far) back into it
			// having retrieved it from the server. And finally we add a callback/listener to be
			// triggered every time the trainee enters a key...
			CKEDITOR.replace( 'editor1' );
			CKEDITOR.config.toolbar = [
				['Bold','Italic','Underline','StrikeThrough','-','Undo','Redo','-','Cut','Copy','Paste','Find','Replace','-','Print'],
				['NumberedList','BulletedList','-','JustifyLeft','JustifyCenter','JustifyRight','JustifyBlock'],
				['Styles','Format','Font','FontSize'],
			] ;
			// One would expect decodeURI() and encodeURI() to be the reverse of each other!
			// Coding here I found that the / character is escaped with a \ before it. No
			// doubt this is an internet security thing that we don't want it in the url!
			// Hence we encodeURI() the html from the ckeditor on its way from the browser
			// to the server. But call decodeURI() AND replace \/ with / before we put it
			// back into the ckeditor...
			var response_converted = decodeURI( itemInfo.response ).replace( "\\\/", "\/" );
			CKEDITOR.instances['editor1'].setData( response_converted );
			CKEDITOR.instances['editor1'].on('change', function() {
					// Note this could be changed to only update the server ever second rather
					// than every keystroke. Every keystroke could cause network traffic issues.
					var resp = CKEDITOR.instances['editor1'].getData();
					resp = encodeURI( resp );
					$.ajax({
						url: 'mct-item-response.php',
						data: {
									item: q.id,
									r: resp,
									rt: new Date().getTime(),
									_token: csrf_token
						},
						success: function(data){
							// console.log(data);
						},
						error: function(data){
							// console.log(data);
						},
						type: 'GET'
					});
			});
		}

		//////////////////////////////////////////////////////////////////////

		function updateTheStatusMatrix()
		{
			// This function removes the black rectangle from the last question
			// selected and adds a black rectangle to the currently selected question.
			var tdEl, i, n;
			for ( i = 0, n = examInfo.items.length ; i < n ; i++ ) {
				tdEl = getItemStatusEl( i );
				if ( i == g_currentItemIndex ) {
					YAHOO.util.Dom.addClass( tdEl, "currentItem" );
				} else {
					YAHOO.util.Dom.removeClass( tdEl, "currentItem" );
				}
			}
		}

		//////////////////////////////////////////////////////////////////////
	/**
	 * Display an item in the main item pane
	 */
	function originalDisplayItem(itemInfo) {

		var i,n;
		var q = itemInfo.item;
		var liEl, radioEl, spanEl, tdEl, itemPaneEl, imgEl, imgEls, zoomImgEl;
		var itemPaneId;
				// console.log( "DUDE " + q.question_type );

		var is_game_question = new RegExp('^\\s*<span>\\\s*' + escapeRegExp(cfg.gameQuestionIdentifierHead), "").test(q.questionText)
			&& new RegExp(escapeRegExp(cfg.gameQuestionIdentifierTail) + '\\s*<\\s*\\\/\\s*span>\\s*$', "").test(q.questionText)

		// console.log('^\\s*<span>\\\s*' + escapeRegExp(cfg.gameQuestionIdentifierHead));
		// console.log(escapeRegExp(cfg.gameQuestionIdentifierTail) + '\\s*<\\s*\\\/\\s*span>\\s*$');
		// console.log(new RegExp('^\\s*<span>\\\s*' + escapeRegExp(cfg.gameQuestionIdentifierHead), "").test(q.questionText));
		// console.log(RegExp(escapeRegExp(cfg.gameQuestionIdentifierTail) + '\\s*<\\s*\\\/\\s*span>\\s*$', "").test(q.questionText));
		// console.log(is_game_question);
		// console.log(q.questionText);
		if (is_game_question) var questionBody = renderGameQuestion(q.questionText,g_currentItemIndex,itemInfo.response);
		else {
			var questionBody = q.questionText.replace(/\[eq\](.*?)\[\/eq\]/g, function(match, contents, offset, input_string)
			{
				return "<span class='mimetex2katex'>"+match.replace(/\[\/*eq\]/g,"")+"</span>";
			}
		);

		}
		// Mantis #1740: item number and item heading to be stylable.
		var itemStemHTML =
			"<span class='itemNumber'>"
			+ (g_currentItemIndex+1)
			+ ".</span> "
			+ "<span class='itemHeading'>"
			+ (!cfg.hideQuestionHeader ? q.heading : "")
			+ "</span>"

		if (cfg.enableQuestionComment) {
			loadItemCommentModal()
			console.log('load comment modal');
		}

		itemStemHTML += (!cfg.hideQuestionHeader ? "<br /><br />" : "")
			+ questionBody
			+ ( q.imageId != null ? "<img class='itemImage' src='../../img/320x240/" + q.imageId + ".jpg' />" : "")
			;

		itemStemEl.innerHTML = itemStemHTML;

		itemAnswersEl.innerHTML="";
		itemAnswersListEl = document.createElement("ul");
		itemAnswersListEl.id="oleAnswersList";

		// Mantis 0002073. In feedback mode, once an item/question has been answered,
		// it should be greyed out
		if ( cfg.showFeedback && itemInfo.response != null ) {
			itemAnswersListEl.setAttribute( "class", "disabledAnswers" );
		}
		itemAnswersEl.appendChild(itemAnswersListEl);

		for (i = 0; i < q.answers.length; i++) {
			var ignorePatern = new RegExp('.*' + escapeRegExp(cfg.hiddenAnswerPattern) + '.*', "");

			liEl = document.createElement("li");
			if (ignorePatern.test(q.answers[i])) liEl.style.display = "none";

			var answerBody = q.answers[i].replace(/\[eq\](.*?)\[\/eq\]/g, function(match, contents, offset, input_string)
				{
					return "<span class='mimetex2katex'>"+match.replace(/\[\/*eq\]/g,"")+"</span>";
				}
			);

			// Mantis 0002073. In feedback mode, need to add the participant response
			// to the radio element
			// Mantis 0002252. In preview mode, add the correct response to the
			// the radio element
			if ( cfg.showFeedback || cfg.isPreview ) {
				radioEl = createRadioEl (
							"rb_" + i,
							"ir_" + q.id,
							(itemInfo.response === i ? " checked='yes' " : ""),
							i,
							itemInfo.response
							);
			} else {
				radioEl = createRadioEl (
							"rb_" + i,
							"ir_" + q.id,
							(itemInfo.response === i ? " checked='yes' " : ""),
							i,
							0
							);
			}
			radioEl.itemIndex = g_currentItemIndex;
			radioEl.displayTime = new Date().getTime();

			// Already answered
			if (itemInfo.response === i) {
				radioEl.checked = true;
			}

			liEl.appendChild(radioEl);

			// Experimental change to accommodate images in answers. Instead of text
			// node inserted into li element, will put SPAN container into which we can
			// insert arbitrary HTML (including IMG tags).
			spanEl = document.createElement("span");
			spanEl.innerHTML = answerBody;
			liEl.appendChild(spanEl);

			itemAnswersListEl.appendChild(liEl); // this one has the click handler

			// Mantis 0002073. In Show Feedback mode, disallow further changes to an item
			// once participant has submitted answer
			if ( cfg.showFeedback && !cfg.isPreview ) {
				if ( itemInfo.response == null ) {
					// Set click handler on each radio button
					try{
						YAHOO.util.Event.on(radioEl,"click", function(){
							// Mantis 0002121. Don't respond to clicks if response are
							// temporarily disabled
							if ( responsesEnabled ) {
								updateRadioWidget(this); // If non-native radio need to update
								clearError();
								submitItemBtnEl.disabled = false;
								selectedRadioElement = this;
							}
						});
					} catch (e) {
						alert (e);
					}
				}
			} else {
				// Set click handler on each radio button
				if ( !cfg.isPreview ) {
					try{
						YAHOO.util.Event.on(radioEl,"click", function(){
							// Mantis 0002121. Don't respond to clicks if response are
							// temporarily disabled
							if ( responsesEnabled ) {
								updateRadioWidget(this); // If non-native radio need to update
								clearError();
								sendItemResponse (this);
								selectedRadioElement = this;
							}
						});
					} catch (e) {
						alert (e);
					}
				}
			}
		}



		var equationElements = document.getElementById("oleItem").getElementsByClassName("mimetex2katex");
		for(var i = 0; i < equationElements.length; i++) {
			katex.render(equationElements[i].innerHTML.replace(/&amp;/g,"&"), equationElements[i]);

		}


		// Indicate which item is current in the status matrix
		for (i = 0, n = examInfo.items.length; i < n; i++) {
			tdEl = getItemStatusEl(i);
			if ( i == g_currentItemIndex) {
				YAHOO.util.Dom.addClass(tdEl,"currentItem");
			} else {
				YAHOO.util.Dom.removeClass(tdEl,"currentItem");
			}
		}

		// Unsure/doubt flag
		if (USE_FLAG_ITEM_CHECKBOX) {
			flagItemCbEl.checked = isFlagged(g_currentItemIndex);
		}
		if (USE_FLAG_ITEM_BUTTON) {
			flagItemBtn.flagged = isFlagged(g_currentItemIndex);
			flagItemBtn.checked = isFlagged(g_currentItemIndex);
			flagItemBtn.className = flagItemBtn.flagged ? "flagged" : "";
		}

		// image thumbnailing
		itemPaneId = "mainPane";
		itemPaneEl = document.getElementById( itemPaneId );
		imgEls = document.getElementById(itemPaneId).getElementsByTagName("img");
		for (i = 0; i < imgEls.length; i++) {

			// Exclude mimetex images
			if (YAHOO.util.Dom.hasClass(imgEls[i],"mimetex") ) {
				  continue;
			}

			// Change this to choose the initial size, can be:
			// thumbnail
			// medium
			// expanded
			var initialSize = cfg.imageDisplayInitialSize;

			YAHOO.util.Dom.addClass(imgEls[i],initialSize);


			YAHOO.util.Event.addListener(imgEls[i],"click", function (o) {
				// Internet Explorer bugs and quirks
				if (typeof o.target != 'undefined') {
					imgEl = o.target;
				} else {
					// IE < 9
					imgEl = o.srcElement;
				}

				if (cfg.optItemImagePopups === false) {
					// Item images expandable inline
					if ( YAHOO.util.Dom.hasClass(imgEl,initialSize) ) {
						YAHOO.util.Dom.removeClass(imgEl,initialSize);
						YAHOO.util.Dom.addClass(imgEl,"expanded");
					} else {
						YAHOO.util.Dom.addClass(imgEl,initialSize);
						YAHOO.util.Dom.removeClass(imgEl,"expanded");
					}
				} else {
					// Item images as popups
					zoomImgEl = document.createElement("img");
					zoomImgEl.src = imgEl.src;

					YAHOO.util.Event.addListener(zoomImgEl,"click", function (e) {
							imgZoomPanel.hide();
							YAHOO.util.Dom.setStyle('imageOverlay', 'display', 'none');
					});

					imgZoomPanel.setBody(zoomImgEl);
					if ( YAHOO.util.Dom.hasClass(imgEl,initialSize) ) {

						imgZoomPanel.show();
						YAHOO.util.Dom.setStyle('imageOverlay', 'display', 'block');
					}
				}

			});
		}
	}

	function saveItemCommentModal(){
		console.log('saving comment ...')
		var comment_text_area = $('#oleCommentItemModalText')
		var comment_to_save = comment_text_area.val();
		var is_removing = comment_to_save.match(/^\s*$/);

		var request = {
			exam_id: cfg.mctId,
			item: g_currentItemIndex,
			comment: comment_to_save,
			rt: new Date().getTime(),
			_token: csrf_token
		};
		console.log('request_put',request);
		$.ajax({
			url: 'question/comment',
			data: request,
			// dataType: 'json',
			success: function(data){
				console.log('success',data);
				$('#oleCommentItemModal').modal('hide');
				comment_text_area.val('');

				var matrix_cell_item_selector = '#oleItemStatusTable td#q_'+g_currentItemIndex;
				if(is_removing) $(matrix_cell_item_selector).removeClass('matrix-item-commented');
				else $(matrix_cell_item_selector).addClass('matrix-item-commented');
			},
			error: function(data){
				console.log("error",data);
			},
			type: 'PUT'
		});
	}

	function loadItemCommentModal(){

		// take the title from page
		$('#oleCommentItemModalTitle').html('');
		$('#oleCommentItemModalTitle').append($('.itemNumber').clone());
		$('#oleCommentItemModalTitle').append($('.itemHeading').clone());


		var request = {
			exam_id: cfg.mctId,
			item: g_currentItemIndex,
			rt: new Date().getTime(),
			_token: csrf_token
		};
		console.log('request_get',request);
		$.ajax({
			url: 'question/comment',
			data: request,
			// dataType: 'json',
			success: function(data){
				console.log('success',data);
				$('#oleCommentItemModalText').val(data['comment']);
				$('#oleCommentItemModalText').focus();
			},
			error: function(data){
				console.log("error",data);
				$('#oleCommentItemModalText').focus();
			},
			type: 'GET'
		});

	}

	/**
	 * Send item response when a radio button is selected.
	 *
	 * Mantis 0002121: Modified the behaviour of this function to handle the situation
	 * where the exam is paused. (This can happen if the participant answers an item
	 * before his/her screen updates.) In this case the item state is now reverted to
	 * what it was before, and the progress bar and status matrix are not updated.
	 *
	 * @return void
	 */
	function sendItemResponse (radioEl) {

		var now = new Date().getTime();
		var url, tdEl, alertTimerId;
		var itemUpdate;
		var answerTime = now - radioEl.displayTime;

		// New non-native radio buttons allow for unchecking. So
		// make sure radioEl is checked before sending to server.
		// If unchecked sent a -1 to server to indicate that this
		// item should not be unanswered.
		var answerIndex;
		if (isRadioButtonChecked(radioEl)) {
			answerIndex = radioEl.answerIndex;
		} else {
			answerIndex = -1;
		}

		url = cfg.mctResponseUrlFn (cfg.mctId, g_currentItemIndex, answerIndex, answerTime);

		tdEl = getItemStatusEl(g_currentItemIndex);

		YAHOO.util.Dom.addClass(tdEl,"sending");
		// Mantis 0002121: Block UI until server responds, or for a fixed period.
		// If client is awaiting responses to more than one item submission,
		// problems can arise if they come back in an unexpected order
		blockUI();
		alertTimerId = setTimeout ( unblockUI, cfg.waitResponseTime );

		YAHOO.util.Connect.asyncRequest ("POST",url, {
			success: function (o) {

				// Mantis 0002235 - Rewrote so that the examInfo attribute is
				// updated and item matrix and progress bar are updated based on
				// that, rather than updating the matrix directly.
				itemUpdate = YAHOO.lang.JSON.parse(o.responseText);

				if (itemUpdate.status != "ok") {

					// Mantis 0002196 Don't display an error message to user if
					// the message is simply that the exam has been paused.
					if ( itemUpdate.code != 504 ) {
						reportError ( itemUpdate.message + " code=" + response.code );
					}
					if ( itemUpdate.code == 503 || itemUpdate.code == 504 ) {
						radioEl.displayTime = now;
						updateItemMatrix();
						updateProgressBar();
					}
					YAHOO.util.Dom.removeClass( tdEl,"sending" );

				} else {

					// Reset item displayTime
					radioEl.displayTime = now;
					if (answerIndex == -1) {
						// not answered
						examInfo.items[g_currentItemIndex].response = null;
					} else {
						// answered
						examInfo.items[g_currentItemIndex].response = answerIndex;
					}
					updateExamInfo( examInfo.items );
					updateItemMatrix();
					updateProgressBar();
				}

				clearTimeout ( alertTimerId );
				unblockUI();
				YAHOO.util.Dom.removeClass(tdEl,"sending");
			},
			failure: function (o) {
				// asyncLog('Failed to sendItemResponse',null,o.responseText);
				displayConnectionError (o);
			}
		});
	}


	/**
	 * Blocks user actions in GUI. Note that this will prevent Participant
	 * from ALL interaction with the system. If it is ever called, unblockUI()
	 * should always be called after a fixed interval to restore responsiveness
	 * Introduced in response to Mantis 0002121.
	 */
	function blockUI() {

		// Disable answering of questions
		responsesEnabled = false;
		// Disable toolbar buttons
		prevItemBtnEl.disabled = 1;
		nextItemBtnEl.disabled = 1;
		flagItemBtn.disabled = 1;
		commentItemBtn.disabled = 1;
		// Mantis 0002178 Corrected name of the button element...
		submitBtnEl.disabled = 1;
	}


	/**
	 * Restores user actions in GUI.
	 * Introduced in response to Mantis 0002121.
	 */
	function unblockUI() {

		// Enable answering of questions
		responsesEnabled = true;
		// Enable Navigation buttons
		prevItemBtnEl.disabled = (g_currentItemIndex === 0);
		nextItemBtnEl.disabled = (g_currentItemIndex === examInfo.items.length-1);
		flagItemBtn.disabled = 0;
		commentItemBtn.disabled = 0;
		// Mantis 0002178 Corrected name of the button element...
		submitBtnEl.disabled = 0;
	}



	/**
	 * Send item response and handle feedback. Call when Submit Question
	 * button is clicked, not when answer is selected.
	 * Introduced in response to Mantis 0002073
	 * @author Michael Cullen
	 * @return void
	 */
	function sendItemResponseForFeedback (radioEl) {

		var now = new Date().getTime();
		var answerTime = now - radioEl.displayTime;
		var url, tdEl, alertTimerId, itemUpdate;

		// New non-native radio buttons allow for unchecking. So
		// make sure radioEl is checked before sending to server.
		// If unchecked sent a -1 to server to indicate that this
		// item should not be unanswered.
		var answerIndex;
		if (isRadioButtonChecked(radioEl)) {
			answerIndex = radioEl.answerIndex;
		} else {
			answerIndex = -1;
		}

		url = cfg.mctResponseUrlFn (cfg.mctId, g_currentItemIndex, answerIndex, answerTime);
		tdEl = getItemStatusEl(g_currentItemIndex);
		YAHOO.util.Dom.addClass(tdEl,"sending");

		// Mantis 0002121: Block UI until server responds, or for a fixed period.
		// If client is awaiting responses to more than one item submission,
		// problems can arise if they come back in an unexpected order
		blockUI();
		alertTimerId = setTimeout ( unblockUI, cfg.waitResponseTime );

		YAHOO.util.Connect.asyncRequest ("POST",url, {

			success: function (o) {
				itemUpdate = YAHOO.lang.JSON.parse(o.responseText);
				if (itemUpdate.status != "ok") {

					// Mantis 0002196 Don't display an error message to user if
					// the message is simply that the exam has been paused.
					if ( itemUpdate.code != 504 ) {
						reportError ( itemUpdate.message + " code=" + itemUpdate.code );
					}
					if ( itemUpdate.code == 503 || itemUpdate.code == 504 ) {
						radioEl.displayTime = now;
						updateItemMatrix();
						updateProgressBar();
					}

				} else {

					examInfo.items[g_currentItemIndex].response = answerIndex;
					updateExamInfo( examInfo.items );
					updateItemMatrix();
					updateProgressBar();
				}

				clearTimeout ( alertTimerId );
				unblockUI();

				YAHOO.util.Dom.removeClass( tdEl, "sending" );

				// Display Feedback Message
				oleAlert( itemUpdate.message, itemUpdate.code );
			},
			failure: function (o) {
				// asyncLog('Failed to sendItemResponseForFeedback',null,o.responseText);
				displayConnectionError (o);
			}
		});

		// Reset item displayTime
		radioEl.displayTime = now;

		// Update item status
		tdEl.answerIndex = answerIndex;

		// Redraw question, as it should be greyed out now that it's been
		// answered
		getAndDisplayItem( g_currentItemIndex );
		submitItemBtnEl.disabled = true;
	}


	/**
	 * Return the number of items that have been answered
	 * @return integer The number of items of the MCT that have been answered.
	 */
	function getAnsweredCount () {

		var i, count = 0;
		for ( i = 0; i < examInfo.items.length; i++ ) {
			if ( examInfo.items[i].response != null ) {
				count++;
			}
		}
		return count;
	}


	/**
	 * Update the state of the progress bar (if enabled).
	 * @return void
	 */
	function updateProgressBar() {

		var v, maxw, w;
		if (! cfg.progressBarEnable) {
			return;
		}

		v = getAnsweredCount();
		progressBarMsgEl.innerHTML = v + " / " + examInfo.items.length;
		var percentage_slider = v / (examInfo.items.length) * 100;
		// maxw = progressBarEl.clientWidth;
		// w = v * maxw / examInfo.items.length;
		// progressBarSliderEl.style.width= w + "px";
		var bg_style = 'linear-gradient(90deg, #88f '+percentage_slider+'%, transparent '+percentage_slider+'%)';
		// console.log(percentage_slider,bg_style);
		progressBarEl.style.background = bg_style;
	}


	/**
	 * Submit an MCT for feedback. Called when the user clicks the submit question button
	 * Introduced in response to Mantis 0002073
	 * @author Michael Cullen
	 */
	function submitItemForFB () {

		sendItemResponseForFeedback( selectedRadioElement );
	}


	/**
	 * Submit a MCT. Issued in respones to user clicking Submit button and confirming action.
	 * @return void
	 */
	function submitMCT () {

		var message = "";

		var i, n, nFlagged = 0, url;

		var answerCount = getAnsweredCount();
		var numUnanswered = examInfo.items.length - 0 - answerCount;
		if (numUnanswered == 1) {
			message += numUnanswered + " " + cfg.oneUnansweredMessage + "<br><br>\n\n" ;
		}
		if (numUnanswered > 1) {
			message += numUnanswered + " " + cfg.multiUnansweredMessage + "<br><br>\n\n" ;
		}


		for (i = 0, n = examInfo.items.length; i<n; i++) {
			if (isFlagged(i)) {
				nFlagged++;
			}
		}
		if (nFlagged == 1) {
			message +=
				+ nFlagged + " " + cfg.oneFlaggedMessage + "<br><br>\n\n";
		}

		if (nFlagged > 1) {
			message +=
				+ nFlagged + " " + cfg.multiFlaggedMessage + "<br><br>\n\n";
		}

		var nCommented = $('#oleItemStatusTable [id^="q_"].matrix-item-commented').length;
		if (nCommented == 1) message += nCommented + " Question is commented.<br><br>\n\n";
		if (nCommented > 1)  message += nCommented + " Questions are commented.<br><br>\n\n";

		message += cfg.confirmSubmitMessage;


		confirm( message, function() {

			// We're ok to submit
			url = cfg.mctSubmitUrlFn(cfg.mctId);
			YAHOO.util.Connect.asyncRequest ("POST",url, {
				success: function (o) {
					window.location=cfg.mctOverUrlFn(cfg.mctId);
				},
				failure: function (o) {
					// asyncLog('failed to submitMCT');
					alert (o.responseText);
				}
			});
		});

	}

    var hb_promise = null;
    const delay = ms => new Promise(res => setTimeout(res, ms));

	/**
	 * Send periodic heartbeat to keep session alive. TODO: adapt to implement alert service.
	 * @return void
	 */
	async function heartBeat () {
		if(hb_promise !== null) {
			// heartbeat prevented if another hb is ongoing
			return;
		}

		// console.log( "In heartbeat - making ajax call..." );

		hb_promise = $.ajax({
			url: cfg.heartbeatUrlFn( new Date().getTime(), isClockRunning(), clockStartValue, clockStartTime, userId ),
			timeout: 8000,
			dataType: 'json',
			success: function(response) {
                // Check if exam is over and redirect to end page if so
				// Status codes:
				// 0 : all is normal
				// 450: exam submitted (Updated to handle this case, see Mantis 0002181)
				// 451: exam is over
				// 452: exam voluntarily submitted
				// 453: exam timeout
				// 454: terminated by examiner (individual)
				// 455: terminated by examiner (all)
				// 460: Session has disappeared! (Can occur legitimately in preview mode)
				if ( (response.status == 460) && cfg.isPreview ) {
					stopBackgroundTasks();
					window.close();
					return false;
				} else if ( (response.status == 460) && !cfg.isPreview ) {
					window.location = cfg.loginUrlFn();
				}

				if (response.status >= 450 && !cfg.isPreview ) {
					stopBackgroundTasks();
					console.log("response.status >= 450, exiting the exam")
					window.location=cfg.mctOverUrlFn(cfg.mctId);
					return false;
				}

				if (isClockRunning() && (response.ck === 0) ) {
					clockPause();
				}

				if ( !isClockRunning() && (response.ck === 1) ) {
					clockStartValue = response.tr;
					clockStartTime = new Date().getTime();
					clockResume();
				}
            },
            error: function (error) {
                console.log("error in heartbeat ajax",error);
            },
            complete: async function(response){
                // completed heartbeat waiting 1 sec to free the promise...
                await delay(cfg.heartbeatInterval);
                // heartbeat completed, freeing promise variable
                hb_promise = null;
            }
		});
	}


	/**
	 * Called on UI component creating to load MCT metadata and display first item.
	 * @return void
	 */
	function startAssessment () {

		var footerEl, itemPaneEl, itemEl, tableEl;
		var footerText;
		var metadataUrl, answeredCount;

		// Mantis 0002235. Optionally add the exam widget version number
		// to the footer
		if ( cfg.showClientVersion ) {

			footerEl = document.getElementById( 'ft' );
			footerText = document.getElementById( 'ft' ).innerHTML;
			footerEl.innerHTML = footerText.replace( '©', '(' + cfg.versionMessage  + ' '
								 + VERSION + ') ' + '&nbsp;&nbsp;©' );
		}

		// Setup UI elements
		itemPaneEl = document.getElementById(cfg.itemPaneId);

		// Create a panel for displaying important messages / alerts
		alertEl = document.createElement("div");
		alertEl.id="oleAlert";
		itemPaneEl.appendChild(alertEl);

		// Optional button bar -- keep all the buttons in one row
		// Required for PJN modifications 19 Sep 2011.
		if (cfg.useButtonBar) {
			buttonBarEl = document.getElementById(cfg.buttonBarId);
		}

		itemEl = document.createElement("dl");
		itemEl.id="oleItem";
		itemPaneEl.appendChild(itemEl);

		// This is where the stem (question text goes)
		itemStemEl = document.createElement("dt");
		itemStemEl.id = "oleItemStem";
		itemEl.appendChild(itemStemEl);

		// This is where the key and distractors (answers) go
		itemAnswersEl = document.createElement("dd");
		itemAnswersEl.id="oleItemAnswers";
		itemEl.appendChild(itemAnswersEl);

		// Create previous item button
		prevItemBtnEl = document.createElement("button");
		prevItemBtnEl.id="olePrevItemBtn";
				prevItemBtnEl.title = "Previous Question";
		(cfg.useButtonBar ? buttonBarEl : itemPanelEl).appendChild(prevItemBtnEl);

		// Create next item button
		nextItemBtnEl = document.createElement("button");
		nextItemBtnEl.id="oleNextItemBtn";
				nextItemBtnEl.title = "Next Question";
		(cfg.useButtonBar ? buttonBarEl : itemPanelEl).appendChild(nextItemBtnEl);

		// Create flag item wrapper DIV element
		flagItemDivEl = document.createElement("div");
		flagItemDivEl.id="oleFlagItemDiv";
		flagItemDivEl.innerHTML="&nbsp;";
		itemPaneEl.appendChild(flagItemDivEl);


		if ( USE_FLAG_ITEM_BUTTON ) {
			flagItemBtn = document.createElement("button");
			flagItemBtn.id="oleFlagItemBtn";
			flagItemBtn.title="Flag Question for Attention";  // cfg.flagItemBtnHelp;

			YAHOO.util.Event.addListener(flagItemBtn, "click", toggleItemFlag_BtnVer);
			(cfg.useButtonBar ? buttonBarEl : flagItemDivEl).appendChild(flagItemBtn);
			if ( cfg.isPreview ) {
				flagItemBtn.disabled = 1;
			}
		}

		// Create comment item wrapper DIV element
		commentItemBtn = document.createElement("button");
		if(cfg.enableQuestionComment){
			commentItemBtn.id="oleCommentItemBtn";
			commentItemBtn.title="Add Comment on this Question";
			(cfg.useButtonBar ? buttonBarEl : flagItemDivEl).appendChild(commentItemBtn);
			var commentItemBtnJq = $('#oleCommentItemBtn');
			commentItemBtnJq.addClass("ole-nav-btn");
			commentItemBtnJq.attr('data-toggle', 'modal');
			commentItemBtnJq.attr('data-target', '#oleCommentItemModal');
			commentItemBtnJq.append($('<i class="fas fa-solid fa-note-sticky fa-2x"></i>'))
			$('#oleCommentItemModalSaveBtn').click(saveItemCommentModal);
			$('#oleCommentItemModal').on('show.bs.modal', loadItemCommentModal)
			// YAHOO.util.Event.addListener(commentItemBtn, "click", toggleItemFlag_BtnVer);
			if ( cfg.isPreview ) commentItemBtn.disabled = 1;
		}

		//
		// MCT status panel
		//

		mctStatusEl = document.getElementById(cfg.mctStatusPaneId);

		// Create progress bar DIV and widget if enabled in configuration
		if (cfg.progressBarEnable) {
			progressBarEl = document.createElement("div");
			progressBarEl.id="oleProgressBar";
			mctStatusEl.appendChild(progressBarEl);

			progressBarMsgEl = document.createElement("span");
			progressBarMsgEl.className = "msg";
			progressBarEl.appendChild(progressBarMsgEl);

			progressBarSliderEl = document.createElement("div");
			progressBarSliderEl.className="slider";
			progressBarEl.appendChild(progressBarSliderEl);
		}

		// Create place holder for item status table
		itemStatusEl = document.createElement("div");
		mctStatusEl.appendChild(itemStatusEl);

		// Mantis 002073 Add a Submit Item Button if required
		if ( cfg.showFeedback ) {
			submitItemBtnEl = document.createElement( "button" );
			submitItemBtnEl.id = "olesubmitItemBtn";
						submitItemBtnEl.title = "Submit your Answers and Exit Exam.";
			submitItemBtnEl.disabled = true;
			if ( !cfg.isPreview ) {
			YAHOO.util.Event.on( submitItemBtnEl,"click",submitItemForFB );
			}
			(cfg.useButtonBar ? buttonBarEl : mctStatusEl).appendChild( submitItemBtnEl );
		}

		// Create MCT submit button and attach click handler
		// Mantis 0002252. Don't do this in preview mode (JS can't close a window/tab
		// it didn't open, so making this a close button is not on.)
		if ( !cfg.isPreview ) {
		submitBtnEl = document.createElement("button");
		submitBtnEl.id = "oleSubmitBtn";
				submitBtnEl.title = "Submit your Answers and Exit Exam.";
		YAHOO.util.Event.on(submitBtnEl,"click",submitMCT);
		(cfg.useButtonBar ? buttonBarEl : mctStatusEl).appendChild(submitBtnEl);
		}
		// Register button click handlers
		YAHOO.util.Event.addListener(prevItemBtnEl, "click", prevItem);
		YAHOO.util.Event.addListener(nextItemBtnEl, "click", nextItem);


		// Instantiate a Panel from markup
		imgZoomPanel = new YAHOO.widget.Overlay("imageOverlay", {
					// x:0,y:0,
					// y:100,
					 // width:"1200px",
					// height:"600px",
					visible:false,
					// constraintoviewport:true,
					// fixedcenter:true,
					close:true,
					modal:true
		} );

		imgZoomPanel.render("doc2");
		YAHOO.util.Event.addListener(imgZoomPanel,"click", function (e) {
			alert ('zoom panel click');
		});

		// Generate MCT metadata URL and issue GET request
		metadataUrl = cfg.mctMetadataUrlFn( cfg.mctId );
		YAHOO.util.Connect.asyncRequest ("GET",
				metadataUrl + "&t=" + new Date().getTime(), {
			success: function (o) {

				// Parse metadata and keep object for future reference
				examInfo = YAHOO.lang.JSON.parse(o.responseText);

				//g_questions = examInfo.items;
				answeredCount = 0;

				//progressBar.set('maxValue',examInfo.items.length);
				updateProgressBar();
				//progressBar.render(progressBarEl);

				// Create matrix of question numbers in right column
				tableEl = createQuestionMatrixIE (examInfo.items);
				itemStatusEl.appendChild(tableEl);

				// Create DOM structure for clock
				if (cfg.clockId != null) {
					clockDivEl = document.getElementById(cfg.clockId);
					if (clockDivEl != null) {
						clockEl = document.createElement("span");
						clockEl.id = "oleClock";
						clockDivEl.appendChild(clockEl);
					}
				}

				// Mantis 0002328: Different styling (for different text)
				// in elapsed time mode.
				if ( cfg.elapsedTime ) {
					YAHOO.util.Dom.addClass( clockDivEl, "elapsedTime" );
				} else {
					YAHOO.util.Dom.addClass( clockDivEl, "timeRemaining" );
				}

				updateClockDisplay(examInfo.timeRemaining);

				// Clock is paused by defult on start up.
				clockPause();

				// Start clock and heartbeat background tasks if applicable
				startBackgroundTasks();

				g_currentItemIndex = 0;
				getAndDisplayItem(0);

				// Run the first heartbeat immediately (subsequent hb by timer)
				heartBeat();

			}, // end success() function
			failure: function (o) {
				reportError (o.responseText);
				// asyncLog('failed to startAssessment', null , o.responseText);
			}
		}); // end asyncRequest()
	}


	function displayConnectionError (o){
		if (o.status == 0){
			reportError ("<font color=black>General Network Failure. Time remaning has been paused. Please <a href='#' onclick='location.reload()'>refresh</a> the page.</font>");
		} else {
			alert ( cfg.errorSendingResponseMessage + ' \n'
			+ cfg.urlMessage + ' ' + url
			+ '.\n' + cfg.serverStatusMessage + ' ' + o.status
			+ '.\n' + cfg.serverErrorTextMessage + ' ' + o.responseText);

		}

	}

	function startClockTimer () {

		if ( document.getElementById(cfg.clockId) != null) {
			clockTimer = setInterval ("OLE.updateClock()", 1000);
		}
	}

	function stopClockTimer () {
		clearInterval(clockTimer);
	}


	function startBackgroundTasks () {

		startClockTimer();
		if (cfg.heartbeatUrl != null) {
			heartbeatTimer = setInterval ("OLE.heartBeat()", cfg.heartbeatInterval)
		}

	}


	function stopBackgroundTasks () {

		stopClockTimer();
		clearInterval (heartbeatTimer);
		return false;
	}


	/**
	 * YUI Dialog for information messages.
	 */
	function oleAlert(message, code ) {

		var yuiDialog = new YAHOO.widget.SimpleDialog("oleAlert2", {
			width : "640px",
			fixedcenter : true,
			modal : true,
			visible : true,
			draggable : false,
			buttons : [ {
				text : "OK",
				handler : function() {
					yuiDialog.hide();
				}
			} ]
		});

		var result;
		var messageTidy = message.replace(/(\r\n|\\n|\r)/gm,"");
		var messageTidy2 = messageTidy.replace(/\\\//g, "/");

		if ( code == 1 ) {
			result = '<b>' + cfg.correctMessage + '</b><br />';
		} else {
			result = "<b>" + cfg.inCorrectMessage + '</b><br />';
		}

		yuiDialog.setBody( result + messageTidy2 );
		yuiDialog.cfg.setProperty("icon",
				YAHOO.widget.SimpleDialog.ICON_INFO);
		yuiDialog.render(document.body);
		yuiDialog.show();
		yuiDialog.blurButtons();
	}


	/**
	 * Use YUI panel to simulate a alert() but do not block
	 * setInterval() and setTimer() etc.
	 */
	function confirm(message, confirmHandler) {

		var yuiDialog = new YAHOO.widget.SimpleDialog("oleAlert2", {
			width : "640px",
			fixedcenter : true,
			modal : true,
			visible : true,
			draggable : false,
			// Mantis 0002062 - Neither button should be a default - don't want
			// candidate to make assumptions about what to do.
			buttons: [
			{
				text:'<span style="font-size:18px">' + cfg.accept + '</span>',
				handler : function() {
					yuiDialog.hide();
					confirmHandler();
				}
			},
			{
				text:'<span style="font-size:18px">' + cfg.decline + '</span>',
				handler : function() {
					yuiDialog.hide();
				}
			}
			]
		});


		yuiDialog.setBody(message);
		yuiDialog.cfg.setProperty("icon", YAHOO.widget.SimpleDialog.ICON_WARN);
		yuiDialog.render(document.body);
		yuiDialog.show();
		// Mantis 0002062. Remove focus from both buttons so neither looks like
		// a default option
		yuiDialog.blurButtons();
	}


	//
	// Public attributes and methods
	//
	return  {
		version: VERSION,
		init: function (configuration) {
			cfg = configuration;
		},
		render: function () {
			startAssessment();
		},
		// updateClock(),heartBeat() must be public to work with setInterval()
		updateClock: function () {
			updateClock();
		},
		heartBeat: function () {
			heartBeat();
		},
		updateItemMatrix: function () {
			updateItemMatrix();
		},
		refreshExamInfo: function () {
			refreshExamInfo();
		},
	};

}();


